import { Injectable, OnDestroy } from '@angular/core';
import { BehaviorSubject, Observable, Subject } from 'rxjs';
import { UserType } from '../enums/usertype.enums';
import { UserSessionResponse } from '../interfaces';

@Injectable({
  providedIn: 'root',
})
export class UserHttpService {


  constructor() {}

  public get getUserInfo() {
    if(localStorage.getItem('intrasense-user:session')) {
      return JSON.parse(localStorage.getItem('intrasense-user:session') as string) as UserSessionResponse;
    } else {
      return JSON.parse(sessionStorage.getItem('intrasense-user:session') as string) as UserSessionResponse;
    }
  }

  public get userToken() {
    if(localStorage.getItem('intrasense-user:token')) {
      return JSON.parse(localStorage.getItem('intrasense-user:token') as string) as string;
    } else {
      return JSON.parse(sessionStorage.getItem('intrasense-user:token') as string) as string;
    }
  }



}
